import React from "react";
import * as MS from "../../styles/ModelStyled";
import { useDispatch } from "react-redux";
import { setIsModal } from "../../store/action";
import redCross from "../../assets/images/greyCross.png";

const ModalComplete = ({
  component,
  isOpen,
  isClose,
  backColor,
  minWidth,
  maxWidth,
  title,
  theme
}) => {
  const dispatch = useDispatch();
  return isOpen ? (
    <MS.ModalContainer
    >
      <MS.InnerBoxEPCom
        minWidth={minWidth}
        maxWidth={maxWidth}
        backColor={backColor}
        themeColor={theme}
      >
        {" "}
        {isClose ? (
          <MS.CrossRow
          themeColor={theme}
          title={title ? true : false}
            onClick={() => {
              isClose(false);
              dispatch(setIsModal(false));
            }}
          >
            <p>{title}</p>
            <img src={redCross} alt="" />
          </MS.CrossRow>
        ) : (
          ""
        )}
        {component}
      </MS.InnerBoxEPCom>
    </MS.ModalContainer>
  ) : (
    ""
  );
};

export default ModalComplete;
